import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainNavbar = _resolveComponent("MainNavbar")!
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_TermsConditions = _resolveComponent("TermsConditions")!
  const _component_ReservationTable = _resolveComponent("ReservationTable")!
  const _component_TestimonialSlider = _resolveComponent("TestimonialSlider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainNavbar, { class: "style-three" }),
    _createVNode(_component_PageTitle, {
      pageTitle: "Terms & Conditions",
      mainTitle: "Terms & Conditions",
      subTitle: "Where Passion & Ingredients Unite On Your Plate"
    }),
    _createVNode(_component_TermsConditions),
    _createVNode(_component_ReservationTable),
    _createVNode(_component_TestimonialSlider)
  ], 64))
}